import { EcwidProduct, Variant } from '@/lib/ecwid/ecwidTypes';
import { create, StoreApi, UseBoundStore } from 'zustand';
import { devtools } from 'zustand/middleware';

export type VariantState = {
    product: EcwidProduct | undefined;
    setProduct: (product: EcwidProduct | undefined) => void;
    selectedVariant: Variant | undefined;
    setVariantSelected: (variant: Variant | undefined) => void;
    initializeVariant: (variants: Variant[]) => void;
};

export const useVariantStore: UseBoundStore<StoreApi<VariantState>> = create(
    devtools(set => ({
        product: undefined,
        setProduct: product =>
            set(state =>
                state.product === undefined ? { product: product } : state,
            ),
        selectedVariant: undefined,
        setVariantSelected: variant => set({ selectedVariant: variant }),
        initializeVariant: variants =>
            set(state =>
                state.selectedVariant === undefined && variants.length > 0
                    ? { selectedVariant: variants[0] }
                    : state,
            ),
    })),
);
